import React from 'react';
import { Field, Form as FormikForm, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { object, string } from 'yup';

import InputTextField from '$app-web/components/input-text-field';
import SubmitWithLoading from '$app-web/components/submit-with-loading';
import { useResetPassword } from '$app-web/modules/auth/hooks';

import useStyles from './styles';

import { FontAwesomeIcon } from '$common/fontawesome-pro/react-fontawesome';

const initialValues = {
    uid: '',
    token: '',
    newPassword: '',
    confirmPassword: '',
};

const validationSchema = object().shape({
    newPassword: string().newPassword(),
    confirmPassword: string().newPasswordConfirmation('newPassword'),
});

const Form = () => {
    const { uid, token } = useParams();

    const classes = useStyles();
    const { t } = useTranslation();

    const { resetPassword, isSignInLoading, isLoading } = useResetPassword();

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            validateOnMount
            onSubmit={(values, formikActions) => resetPassword({ ...values, uid, token }, formikActions)}
        >
            {({ isValid }) => (
                <FormikForm>
                    <Field
                        name="newPassword"
                        placeholder={t('pdash:password')}
                        type="password"
                        component={InputTextField}
                        fullWidth
                        margin="normal"
                        startAdornment={<FontAwesomeIcon icon={['fal', 'lock-alt']} />}
                    />
                    <Field
                        name="confirmPassword"
                        placeholder={t('pdash:confirm_password')}
                        type="password"
                        component={InputTextField}
                        fullWidth
                        margin="normal"
                        startAdornment={<FontAwesomeIcon icon={['fal', 'lock-alt']} />}
                    />
                    <div className={classes.submitButtonWrapper}>
                        <SubmitWithLoading
                            text={t('pdash:activity_password_reset_change_my_password')}
                            isSubmitting={isLoading || isSignInLoading}
                            disabled={!isValid}
                            buttonProps={{
                                variant: 'contained',
                                color: 'secondary',
                                fullWidth: true,
                            }}
                        />
                    </div>
                </FormikForm>
            )}
        </Formik>
    );
};

export default Form;
